


































import Vue from 'vue'
import { mapActions, mapState, mapGetters } from 'vuex'
import Footer from '../components/all/Footer.vue'
import { NOTIFICA_ERRORE } from '../costanti'

export default Vue.extend({
    components: {
        footerIndex: Footer
    },
    computed: {
        ...mapState('user', ['userInfo']),
        ...mapGetters('user', ['eUnOperatoreGestionaleMapplants', 'eUnOperatoreGestionaleReport'])
    },
    methods: {
        ...mapActions('modal', ['showModal', 'showNotification']),
        logout() {
            this.$store.dispatch('auth/logout')
            this.$router.push({ name: 'Login' })
        },
        apriMapPlants() {
            if (this.eUnOperatoreGestionaleMapplants)
                this.$router.push({
                    name: 'IndexMapPlants', params: {
                        comune: this.userInfo.comune.nome
                    }
                })
            else
                this.showNotification({
                    name: NOTIFICA_ERRORE,
                    title: `Questo servizio non è abilitato su questo utente`
                })
        },
        apriReport() {
            if (this.eUnOperatoreGestionaleReport)
                this.$router.push({
                    name: 'IndexReport', params: {
                        comune: this.userInfo.comune.nome
                    }
                })
            else
                this.showNotification({
                    name: NOTIFICA_ERRORE,
                    title: `Questo servizio non è abilitato su questo utente`
                })
        },
        apriPuntiLuce() {
            this.$router.push({
                name: 'IndexPuntiLuce'
            })
        }
    }
})
